import { render, staticRenderFns } from "./ManualDiscount.vue?vue&type=template&id=08901dcb&scoped=true&"
import script from "./ManualDiscount.vue?vue&type=script&lang=js&"
export * from "./ManualDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ManualDiscount.vue?vue&type=style&index=0&id=08901dcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08901dcb",
  null
  
)

export default component.exports